var w4d = w4d || {};

w4d.modal = {
    init: function () {
        this.register_events();
    },

    /**
     * register_events - Registers event listeners for opening and closing modals.
     *
     * @return {Undefined}
     */
    register_events: function () {
        const showButtons = document.querySelectorAll('.js-open-modal');
        const closeButtons = document.querySelectorAll('.js-close');
        const dialogs = document.querySelectorAll('dialog');

        // Attach event listeners to each "open modal" button
        showButtons.forEach(button => {
            const dialogId = button.getAttribute('data-dialog');
            button.addEventListener('click', e => {
                e.stopPropagation();
                e.preventDefault();
                this.open_modal(dialogId);
            });
        });

        // Attach event listeners to each "close" button
        closeButtons.forEach(button => {
            const dialogId = button.getAttribute('data-dialog');  // Use data attribute instead
            if (dialogId) {
                button.addEventListener('click', e => {
                    e.preventDefault();
                    this.close_modal(dialogId);
                });
            }
        });

        dialogs.forEach(dialog => {
            dialog.addEventListener('click', e => {
                var rect = dialog.getBoundingClientRect();
                var isInDialog = (rect.top <= event.clientY && event.clientY <= rect.top + rect.height &&
                    rect.left <= event.clientX && event.clientX <= rect.left + rect.width);
                if (!isInDialog) {
                    this.close_all_modals();
                }
            });
        });
    },

    /**
     * open_modal - Opens the dialog with the specified ID.
     *
     * @param {String} dialogId - The ID of the dialog to open.
     * @return {Undefined}
     */
    open_modal: function (dialogId) {
        const dialog = document.getElementById(dialogId);
        if (dialog) {
            this.close_all_modals();
            dialog.showModal();
        }
    },

    /**
     * close_modal - Closes the dialog with the specified ID.
     *
     * @param {String} dialogId - The ID of the dialog to close.
     * @return {Undefined}
     */
    close_modal: function (dialogId) {
        const dialog = document.getElementById(dialogId);
        if (dialog) {
            dialog.close();
        }
    },

    /**
     * close_all_modals - Closes all open dialogs.
     *
     * @return {Undefined}
     */
    close_all_modals: function () {
        const dialogs = document.querySelectorAll('dialog[open]'); // Select all open dialogs
        dialogs.forEach(dialog => dialog.close());
    },
}

window.addEventListener('load', function () {
    w4d.modal.init();
});
